module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress-steps"
  }, [_c('sk-progress-linear', {
    staticClass: "progress-steps__bar",
    attrs: {
      "height": (_vm.$breakpoints.xs ? 6 : 10),
      "value": _vm.progress
    }
  }), _vm._v(" "), _vm._l((_vm.numSteps), function(step) {
    return [_c('div', {
      staticClass: "progress-steps__wrapper",
      class: {
        'progress-steps__step--active': step <= _vm.currentStep, 'progress-steps__step--current': step == _vm.currentStep
      }
    }, [_c('div', {
      staticClass: "progress-steps__step",
      on: {
        "click": function($event) {
          _vm.back(step)
        }
      }
    }, [(step < _vm.currentStep) ? _c('sk-icon', {
      attrs: {
        "tick-check": ""
      }
    }) : _c('h4', {
      staticClass: "progress-steps__step-number"
    }, [_vm._v(_vm._s(step) + " a")])], 1), _vm._v(" "), (_vm.stepNames) ? _c('div', _vm._l((_vm.stepNames), function(name) {
      return (step == name.step) ? _c('span', {
        staticClass: "progress-steps__title"
      }, [_vm._v(_vm._s(name.text))]) : _vm._e()
    })) : _vm._e()])]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e9cde346","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/subs-club/progress-steps/progress-steps.vue
// module id = 877
// module chunks = 0